<template>
  <div id="authApp">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "authApp",
  methods: {},
};
</script>

<style lang="less">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.app {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
